import React from 'react'
import PropTypes from 'prop-types'
import { BackgroundFill, Container } from './CircleButtonStyledComponents'

const CircleButton = React.memo(({ isactive, children, fill, ...rest }) => (
  <Container isactive={isactive} {...rest}>
    {children}
    <BackgroundFill fill={fill} />
  </Container>
))

CircleButton.displayName = 'CircleButton'

CircleButton.defaultProps = {
  isactive: true
}

CircleButton.propTypes = {
  isactive: PropTypes.bool,
  fill: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

export default CircleButton
